import { Icon } from '../Icon';

interface ToastProps {
    message: string | null;
}

export function Toast({ message }: ToastProps) {
    if (!message) return null;
    return (
        <div className="fixed bottom-6 right-6 bg-slate-900 text-white text-xs px-4 py-3 rounded-xl shadow-2xl border border-slate-800 flex items-center gap-2 z-50">
            <Icon name="info" className="w-4 h-4 text-indigo-400" />
            <span className="font-medium">{message}</span>
        </div>
    );
}
